import { render, staticRenderFns } from "./scanIdCard.vue?vue&type=template&id=2cc13d22&scoped=true&"
import script from "./scanIdCard.vue?vue&type=script&lang=js&"
export * from "./scanIdCard.vue?vue&type=script&lang=js&"
import style0 from "./scanIdCard.vue?vue&type=style&index=0&id=2cc13d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc13d22",
  null
  
)

export default component.exports